<div>
    <div>
        <app-collapse-button [isActive]="!isEditable" (click)='collapse()'></app-collapse-button>
        <app-reload-button-sm [isActive]="!isEditable && !isLoading" [isLoading]="isLoading" (click)="reload()"></app-reload-button-sm>
        <app-add-button-sm [isActive]="!isEditable && !isLoading" (click)='add()'></app-add-button-sm>
        <div (click)='collapse()' class='group-title' style='cursor: pointer;'>
            Sessions
            <div *ngIf="!isLoading" class='results'>({{sessions.length}})</div>
        </div>
    </div>
</div>

<div [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div *ngIf="!isLoading">
        <div *ngIf='isAdd'>
            <div class='index'>
                <div class='row title' style='display:none;'></div>
                <div>
                    <app-course-session></app-course-session>
                </div>
            </div>
        </div>

        <div [ngClass]="{hide: isAdd}">
            <div class='text-center alert-text' *ngIf="errorMessage">
                {{errorMessage}}
            </div>

            <div *ngIf="!errorMessage">
                <div class='instructions' *ngIf='sessions.length === 0'>
                    No Sessions are associated with this Course. Registered Users will be unable to receive an Evaluation and request a Certificate.
                </div>

                <div class='instructions' *ngIf='sessions.length > 0'>
                    Listed below are the Sessions associated with this Course.
                </div>

                <div class='index'>
                    
                    <div class='row title'>
                        <div class='col-sm-1'>ID</div>
                        <div class='col-sm-11'>Name</div>
                        <!-- <div class='col-sm-2 text-center'>Status</div>
                        <div class='col-sm-3 text-center'>Start Time</div> -->
                    </div>
                    
                    <div class='row' *ngIf='sessions.length === 0'>
                        <div class='col-sm-12 text-center'>
                            There are no Sessions to report for this Course.
                        </div>
                    </div>
                    
                    <div *ngFor="let session of sessions" class='row'>
                        <app-course-session [session]="session"></app-course-session>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>